import classNames from 'classnames';
import { matchesCondition } from '@/lib/use-category-conditions';
import { NavTabProps } from './types';

const NavTab = ({
  currentCondition,
  setCurrentCondition,
  conditions,
}: NavTabProps) => (
  <div
    className={classNames('mt-4 grid gap-2 text-xs', {
      'grid-cols-3': conditions.length === 3,
      'grid-cols-4': conditions.length !== 3,
    })}
  >
    {conditions.map((option) => {
      const isSelected = matchesCondition(option, currentCondition);

      return (
        <button
          key={option.name}
          onClick={() => setCurrentCondition(option.name)}
          className={classNames(
            'flex h-12 items-center justify-center gap-x-2 rounded border px-4',
            {
              'border-gray-700 font-bold': isSelected,
            },
          )}
        >
          {option.name}
        </button>
      );
    })}
  </div>
);

export default NavTab;
